import { render, staticRenderFns } from "./KoioteAutomaticValueLabel.vue?vue&type=template&id=65ea013c&scoped=true"
import script from "./KoioteAutomaticValueLabel.vue?vue&type=script&lang=js"
export * from "./KoioteAutomaticValueLabel.vue?vue&type=script&lang=js"
import style0 from "./KoioteAutomaticValueLabel.vue?vue&type=style&index=0&id=65ea013c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea013c",
  null
  
)

export default component.exports